import { useEffect, useState } from "react";
import api from "./api";

// Curated pro-ballpark backdrops (Unsplash License, free for commercial use). Files live in /public/backdrops.
export const BACKDROPS = [
  { id: "diamond-day", label: "Game day diamond", file: "/backdrops/diamond-day.jpg", pos: "center 35%" },
  { id: "ballpark-aerial", label: "Big-league ballpark", file: "/backdrops/ballpark-aerial.jpg", pos: "center 55%" },
  { id: "stadium-aerial", label: "Diamond from above", file: "/backdrops/stadium-aerial.jpg", pos: "center 45%" },
  { id: "stadium-dusk", label: "Stadium at dusk", file: "/backdrops/stadium-dusk.jpg", pos: "center 60%" },
  { id: "lights-sunset", label: "Under the lights", file: "/backdrops/lights-sunset.jpg", pos: "center 70%" },
  { id: "field-night", label: "Night practice field", file: "/backdrops/field-night.jpg", pos: "center 60%" },
];
export const DEFAULT_BACKDROP = "diamond-day";

let cached = null;
let pending = null;
const fetchSetting = () => {
  if (cached) return Promise.resolve(cached);
  if (!pending) pending = api.get("/settings/public").then(({ data }) => (cached = data.backdrop || DEFAULT_BACKDROP)).catch(() => DEFAULT_BACKDROP);
  return pending;
};
export const resetBackdropCache = () => { cached = null; pending = null; };

const hash = (s = "") => [...s].reduce((h, c) => (h * 31 + c.charCodeAt(0)) >>> 0, 7);

export const pickBackdrop = (setting, seed) => {
  if (setting === "rotate") return BACKDROPS[hash(seed) % BACKDROPS.length];
  return BACKDROPS.find((b) => b.id === setting) || BACKDROPS[0];
};

// Returns the backdrop for a given session id, honoring the admin-selected setting ("rotate" = per-session variety).
export const useBackdrop = (seed) => {
  const [setting, setSetting] = useState(cached || DEFAULT_BACKDROP);
  useEffect(() => { fetchSetting().then(setSetting); }, []);
  return pickBackdrop(setting, seed);
};
